import React from 'react'

import { ImFilePdf } from 'react-icons/im'

import { Box, Flex, Text } from '@chakra-ui/react'

interface PdfThumbnailIProps {
  file: File
  // width: string
}

export const PdfThumbnail = ({ file }: PdfThumbnailIProps) => {
  return (
    <Flex
      _hover={{
        shadow: 'xs',
      }}
      alignItems='center'
      backgroundColor='#ffff'
      border='1px solid #f2f2f2'
      borderRadius='8px'
      cursor='pointer'
      height={50}
      maxWidth={137}
      minWidth={137}
      padding='6px'
    >
      <ImFilePdf color='#E33E25' size='20px' />
      <Box
        flex='1'
        marginLeft='8px'
        overflow='hidden'
        textOverflow='ellipsis'
        whiteSpace='nowrap'
      >
        <Text fontSize='xs' fontWeight='medium' isTruncated>
          {file.name}
        </Text>
        <Text color='gray.500' fontSize='10px'>
          PDF
        </Text>
      </Box>
    </Flex>
  )
}
